export default {"src":"/_next/static/media/G_WhiteLoader.71f36b71.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};